import { useState } from 'react';
import './App.css';
import Header from './Header';
import Banner from './landing/Banner';
import Problem from './landing/Problem';
import Works from './landing/Works';
import Number from './landing/Number';
import System from './landing/System';
import Action from './landing/Action';
import Footer from './Footer';
import DemoModal from './DemoModal';
import AppToast from './AppToast';
import ScrollToTop from './ScrollToTop';

function App() {
  const [showDemoModal, setShowDemoModal] = useState(false);
  const [toast, setToast] = useState({ show: false, message: '' });

  const openDemoModal = () => setShowDemoModal(true);
  const closeDemoModal = () => setShowDemoModal(false);

  const showSuccessToast = (message) => {
    setToast({ show: true, message });
  };

  const hideToast = () => {
    setToast((current) => ({ ...current, show: false }));
  };

  return (
    <div className="App">
      <Header onBookDemo={openDemoModal} />
      <Banner onBookDemo={openDemoModal} />
      <Problem />
      <Works />
      <Number />
      <System />
      <Action onBookDemo={openDemoModal} />
      <Footer onBookDemo={openDemoModal} />
      <DemoModal
        show={showDemoModal}
        onHide={closeDemoModal}
        onSuccess={showSuccessToast}
      />
      <AppToast
        show={toast.show}
        message={toast.message}
        onClose={hideToast}
      />
      <ScrollToTop />
    </div>
  );
}

export default App;
